<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HR20ZU/Cover.jpg?1684514755681" alt="This image is the cover for the book Oliver and Jumpy, Volume 6, Oliver and Jumpy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oliver and Jumpy, Volume 6, Oliver and Jumpy
      </h1>
      <p class="bookDescription body article font2">
        <p>Oliver is an elegant tuxedo cat, who is full of himself. As a matter of fact he says: “I love myself!”, quite often. Naughty, isn’t he? But his best friend Jumpy, a kangaroo lady, is aware that he has a soft heart and will always want to help others. The great thing is Jumpy’s pouch, which Oliver loves to ride in! He calls her his kangaroo taxi! These little bedtime stories with their lovely illustrations are great for small kids. A parent can read the text and tell the child in his own words. These animal stories have sufficient text to keep early readers happy and provide some educational value. Love you all! Meow! Baby Sitting - Oliver is babysitting Bearly. But he disappears while playing hide-and-seek. Who am I? - Oliver is hit by a coconut on the head and loses his memory. Up the Tree - Oliver decides to explore a very tall tree and meets all the animals living there.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Werner Stejskal
      </h2>
      
      <p class="authorDescription body article">Born in Vienna, Austria, Werner is now living in Perth, Australia with his wife, two married children, and three grandchildren. He worked many years in the printing industry and later for the United Nations in Vienna. After an eventful life, now retired, he began to write children's stories, had them illustrated through Upwork, narrated them himself for YouTube and finally published the ebooks on most platforms. Werner's dream is to see "Oliver and Jumpy" animated as a TV series. There are lots of fairy tales and bedtime stories around and many of them quite violent. This made Werner decide to write something different. On a flight from Europe to Australia, he watched the movie Magic on Belle Island with Morgan Freeman, where Freeman teaches a little girl to have imagination and write her first story. This inspired Werner as well and the first stories with his two characters Oliver, the elegant tomcat, and Jumpy, his kangaroo lady friend, made their appearance. Some very capable illustrators have helped to create this picture book series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      www.redjumper.net/bookcreator
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50773b30